import MainSectionHomePage from './MainSectionHomePage';

export default MainSectionHomePage;
